import types from '@/constants/types';

export default {
    [types.UPDATE_USER](state, user) {
        // Clear session if is null
        if (!user) {
            state.user = {
                game_account: {}
            };
            state.userRole = {
                isAdmin: false,
                isDeveloper: false,
                isModerator: false,
            };

            return;
        }
        // Set session else
        const {
            role = state.userRole,
            ...userDetails
        } = user;
        state.userRole = role;
        state.user = userDetails;
    },
    [types.UPDATE_ZP](state, {
        points
    }) {
        if (!state.user.game_account) {
            state.user.game_account = {
                login_fee_point: points
            };
        } else {
            state.user.game_account.login_fee_point = points;
        }
        state.user.zushinPoints = points;
    },
    [types.UPDATE_USER_RESTRICTIONS](state, { restrictions = {
        has_disabled_paypal: 0,
        has_disabled_stripe: 0,
        has_reached_paypal_qualified_amount: false
    } }) {
        state.userRestrictions = restrictions;
    },
    [types.UPDATE_CONFIG](state, {
        config
    }) {
        const newConfig = {
            ...state.config,
            ...config
        }
        state.config = newConfig;
    },
    [types.UPDATE_TOTAL_IN_GAME_ONLINE](state, {
        payload: {
            totalOnline,
            totalOffline
        }
    }) {
        state.inGame = {
            ...state.inGame,
            totalOnline,
            totalOffline
        };
    },
    [types.UPDATE_NOTIFICATIONS](state, { notifications = [] }) {
        state.notifications = notifications;
    },
    [types.SET_LAST_NOTIFICATION_ID](state, lastId) {
        state.lastNotificationId = lastId;
    },
    [types.HIDE_COMPONENT_VISIBILITY](state) {
        state.componentVisibility = {};
    },
    [types.UPDATE_COMPONENT_VISIBILITY](state, payload) {
        state.componentVisibility = {
            ...state.componentVisibility,
            ...payload
        }
    }
};
